// Prevent input that could create malformed JSON or allow SQL injection attacks
const REGEX_MATCH_UNPERMITTED_CHARS = /["\\;\|]/

export const userInputMixin = {
  methods: {
    inputPresent(userInput) {
      return userInput !== null &&
        userInput !== undefined &&
        userInput.length > 0 &&
        userInput.trim() !== ''
    },
    hasUnpermittedCharacters(userInput) {
      return REGEX_MATCH_UNPERMITTED_CHARS.test(userInput)
    },
    matchesPattern(regularExpressionPattern, userInput) {
      if(!regularExpressionPattern) {
        return false
      }

      const regEx = regularExpressionPattern.includes("\\p") // Check for unicode category pattern matcher (https://www.regular-expressions.info/unicode.html)
        ? new RegExp(regularExpressionPattern, 'u') // Use unicode match flag (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/unicode)
        : new RegExp(regularExpressionPattern)
      return regEx.test(userInput)
    },
  }
}
